import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order (1)",
  "use": "icon-order (1)-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-order (1)\"><path d=\"M768 704 384 704l0-64 384 0L768 704zM768 384 384 384l0 64 384 0L768 384zM768 512 384 512l0 64 384 0L768 512zM768 768 384 768l0 64 384 0L768 768z\" p-id=\"14839\" fill=\"#ffffff\" /><path d=\"M128 832l64 0 0 64L128 896 64 896l0-64L64 0l576 0 64 0 0 64 0 64-64 0L640 64 128 64 128 832z\" p-id=\"14840\" fill=\"#ffffff\" /><path d=\"M256 192l0 832 640 0L896 192 256 192zM832 960 320 960 320 256l512 0L832 960z\" p-id=\"14841\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order (1).svg
// module id = 6A3w
// module chunks = 53